<template>
  <ul>
    <!-- BEGIN: First Child -->
    <template v-for="(menu, menuKey) in visibleMenu" :key="menu + menuKey">
      <li
        v-if="menu === 'devider'"
        class="relative z-10 my-6 h-px w-full bg-white dark:bg-slate-500"
      />

      <li
        v-else-if="
          (menu.gate === undefined ||
            (Array.isArray(menu.gate)
              ? menu.gate.some((g) => $can(g))
              : $can(menu.gate)) ||
            (menu.meta && menu.meta.open_for_customer && $can(menu.gate))) &&
          (menu.functionality === undefined ||
            $functionality.module.has(menu.functionality))
        "
      >
        <a
          :href="
            menu.subMenu
              ? 'javascript:;'
              : router.resolve({ name: menu.pageName }).path
          "
          class="side-menu relative mt-1 flex h-11 cursor-pointer items-center justify-center squircle-2xl rounded-lg px-3 text-slate-200 select-none @3xs/menu:justify-start @3xs/menu:pl-3"
          :class="{
            'bg-black/20 text-white': menu.active,
            'hover:bg-black/10': !menu.active,
            'side-menu--open': menu.activeDropdown
          }"
          @click="linkTo(menu, router, $event)"
        >
          <div class="side-menu__icon">
            <FontAwesomeIcon
              :icon="['fal', menu.icon]"
              :fixed-width="true"
              size="lg"
            />
          </div>
          <transition>
            <div
              v-if="!collapsedMenu || expanded"
              class="ml-3 w-full items-center transition-opacity duration-100 ease-linear"
              :class="expanded ? 'flex' : 'hidden lg:flex'"
            >
              <div class="inline-block capitalize-first">
                {{ $t(`navigation.${menu.title}`) }}
              </div>
              <div
                v-if="menu.subMenu"
                class="mr-5 ml-auto transition duration-100 ease-in"
                :class="{ 'rotate-180 transform': menu.activeDropdown }"
              >
                <FontAwesomeIcon
                  :icon="['fal', 'chevron-down']"
                  :fixed-width="true"
                  size="sm"
                />
              </div>
            </div>
          </transition>
        </a>
        <!-- BEGIN: Second Child -->
        <transition @enter="enter" @leave="leave">
          <ul v-if="menu.subMenu && menu.activeDropdown">
            <li v-for="(subMenu, subMenuKey) in menu.subMenu" :key="subMenuKey">
              <a
                :href="
                  subMenu.subMenu
                    ? 'javascript:;'
                    : router.resolve({ name: subMenu.pageName }).path
                "
                class="side-menu cursor-pointer select-none"
                :class="{
                  'side-menu--active font-extrabold text-slate-300 underline':
                    subMenu.active
                }"
                @click="linkTo(subMenu, router, $event)"
              >
                <div class="side-menu__icon">
                  <FontAwesomeIcon
                    :icon="['fal', subMenu.icon]"
                    :fixed-width="true"
                  />
                </div>
                <div
                  class="ml-3 w-full items-center transition-opacity duration-100 ease-linear"
                  :class="collapsedMenu && !expanded ? 'opacity-0' : ''"
                >
                  <div class="inline-block capitalize-first">
                    {{ $t(`navigation.${subMenu.title}`) }}
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </transition>
        <!-- END: Second Child -->
      </li>
    </template>
    <!-- END: First Child -->
  </ul>
</template>
<script>
import { computed, onMounted, ref, watch } from 'vue'
import {
  enter,
  leave,
  linkTo,
  nestedMenu
} from '@/views/layouts/main-layout/index'
import { helper as $h } from '@u/helper'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { mapGetters } from 'vuex'

export default {
  name: 'MainMenu',
  components: { FontAwesomeIcon },
  props: {
    expanded: {
      type: Boolean,
      default: false
    },
    /** Route names to keep (mobile menu); every entry when null. */
    onlyPages: {
      type: Array,
      default: null
    }
  },
  setup() {
    const formattedMenu = ref([])

    const router = useRouter()
    const store = useStore()
    const route = useRoute()
    const sideMenu = computed(() => {
      return nestedMenu(store.state.sideMenu.menu, route)
    })
    watch(
      computed(() => route.path),
      () => {
        formattedMenu.value = $h.toRaw(sideMenu.value)
      }
    )
    onMounted(() => {
      formattedMenu.value = $h.toRaw(sideMenu.value)
    })

    return {
      formattedMenu,
      router,
      linkTo,
      enter,
      leave
    }
  },
  computed: {
    ...mapGetters({
      collapsedMenu: 'sideMenu/collapsedMenu'
    }),
    visibleMenu() {
      if (!this.onlyPages) {
        return this.formattedMenu
      }
      return this.formattedMenu.filter(
        (menu) => menu !== 'devider' && this.onlyPages.includes(menu.pageName)
      )
    }
  }
}
</script>
